export enum STEPS {
  TERMS,
  SIGN,
  PHOTO_ID,
  PHOTO_SELF,
  PERSONAL_DATA,
}
